var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8998 5.3761C15.9382 5.60693 15.8684 5.8523 15.6903 6.03039L15.6872 6.03351L12.8619 8.85881C12.569 9.1517 12.0941 9.1517 11.8012 8.85881C11.5084 8.56591 11.5084 8.09104 11.8012 7.79815L13.3493 6.25006H12C8.82436 6.25006 6.25 8.82442 6.25 12.0001C6.25 15.1757 8.82436 17.7501 12 17.7501C15.1756 17.7501 17.75 15.1757 17.75 12.0001C17.75 11.0813 17.5351 10.2149 17.1534 9.44638C16.9692 9.0754 17.1206 8.6253 17.4916 8.44107C17.8626 8.25683 18.3126 8.40822 18.4969 8.77921C18.9792 9.7504 19.25 10.8447 19.25 12.0001C19.25 16.0041 16.0041 19.2501 12 19.2501C7.99594 19.2501 4.75 16.0041 4.75 12.0001C4.75 7.99599 7.99594 4.75006 12 4.75006H13.3494L11.8013 3.20196C11.5084 2.90907 11.5084 2.43419 11.8013 2.1413C12.0941 1.84841 12.569 1.84841 12.8619 2.1413L15.6903 4.96972L15.6903 4.96973C15.8051 5.08453 15.875 5.2273 15.8998 5.3761Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.d6f706dad917d1ad49bf51dbd2d5988f.svg";
export { ForwardRef as ReactComponent };